module.exports = __webpack_public_path__ + "3bee05504622caa9f5decf03bcb546e5.svg";